import React, { Component } from "react";
import { connect } from "react-redux";
import Config from "@skin_config";
import { ClosePopup } from '@common/actions/ui';
import { LoadCurrencyConfig, SwarmConfigData } from "../actions/initialData";
import { t } from '@common/helpers/translator';
import PropTypes from "prop-types";
import { createSelector } from "reselect";
import { browserHistory } from "@common/helpers/browserHistory";
import { getAuthData } from "@common/helpers/auth";
import { checkTerminalMode } from "@common/helpers";
import { changeDateLocale } from "@common/helpers/dateLocale";
import { getTerminalLanguage } from "../helpers/languageByIdOrConfig";

function mapStateToProps() {
  return createSelector(
    [
      state => state.appReady,
      state => state.user.profile,
      state => state.user,
      state => state.uiState.lastRouteType,
      state => state.swarmConfigData && state.swarmConfigData.cloudAvailable
    ],
    (appReady, profile, user, lastRouteType, cloudAvailable) => {
      return {
        appReady, profile, user, lastRouteType, cloudAvailable
      };
    }
  );
}

/**
 * InitMixin is a HOC(Higher Order Component) which adds init stuff to wrapped component
 *
 * component will wait for appReady to be set in store and then do the initialization,
 * which includes:
 *  - loading partner config from swarm
 *  - loading currency config from swarm
 *  - check if there's saved auth  token and try to log user in if it exists
 *  - set a timer to continuously prolong auth cookie lifetime while browser window is open
 *  - listen to route changes and close popup(if open) when route changes
 *
 * @param {Object} ComposedComponent
 * @constructor
 */

const InitMixin = ComposedComponent => {
  class InitMixin extends Component {
    initialize() {
const terminalLang = getTerminalLanguage();
      Config.main.title && (document.title = t(Config.main.title));
      document.firstElementChild.setAttribute("dir", Config.main.availableLanguages[terminalLang] && Config.main.availableLanguages[terminalLang].rtl ? "rtl" : "ltr");

      changeDateLocale(terminalLang);

      // Load currency config from swarm
      // !OUTDATED
      // !Config.terminal.depositView && checkTerminalMode(Config, 'betting') && this.props.dispatch(LoadCurrencyConfig(getAuthData()?.currency)); //eslint-disable-line react/prop-types

      browserHistory.listen((loc) => {
        this.props.dispatch(ClosePopup(true));  //close popup when route changes(e.g. when clicking "back")
      });
    }
    componentDidMount() {
      this.initialize();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (Config.main.cloudAvailable && nextProps.cloudAvailable) { //Disable BetCloud when location anything else from prematch or live
        let pathname = browserHistory.location.pathname.split("/")[1];

        if (!(pathname === "prematch" || pathname === "live")) {
          this.props.dispatch(SwarmConfigData(false, "cloudAvailable"));
        }
      }

      // if (nextProps.profile && !this.haveProfile) {
      //     this.haveProfile = true;
      //
      // } else {
      //     this.haveProfile = false;
      // }
    }

    render() {
      return <ComposedComponent.Component {...this.props} {...this.state} />;
    }
  }
  InitMixin.propTypes = {
    user: PropTypes.object,
    betslip: PropTypes.object,
    location: PropTypes.object,
    cloudAvailable: PropTypes.bool,
  };
  return connect(mapStateToProps)(InitMixin);
};

export default InitMixin;
